<template>
  <div
    :class="cssClass + ' font-weight-bold'"
    v-bind:style="{
      color: color
    }"
    v-if="score != null || loading"
  >
    <template v-if="loading">
      <v-progress-circular
        indeterminate
        :color="color"
        size="20"
      ></v-progress-circular>
    </template>
    <template v-else>
      <v-icon :size="iconSize" class="mr-2" :color="color">
        {{ $coreScores.getIcon(score) }}
      </v-icon>
      {{ $coreScores.format(score) | no_decimal }}%
    </template>
  </div>
</template>

<script>
export default {
  name: "CoreScoreText",
  components: {},
  props: {
    score: { type: Number },
    loading: { type: Boolean, default: false },
    cssClass: { type: String, default: "" },
    iconSize: { type: Number, default: 12 }
  },
  data: () => ({}),
  computed: {
    color() {
      return this.$coreScores.getColor(this.score);
    }
  },
  methods: {}
};
</script>
